// extracted by css-extract-rspack-plugin
export default {"videoContainer":"BlogVideoEmbed-module__videoContainer","videoIframe":"BlogVideoEmbed-module__videoIframe"};